import React, { PropTypes } from 'react'
import MediaQuery from 'react-responsive'

import './UserProfileNavBar.scss'
import logoAliada from 'images/logo-dark.png'

const desktopWidth = 1024
const UserProfileNavBar = (props) => {
  const {
    title,
    onToggleButtonClick,
    sidebarExpanded
  } = props

  const buttonClass = sidebarExpanded ? 'cross' : 'menu'

  return (
    <div className='UserProfileNavBar'>

      <div className='UserProfileNavBar-left'>

        <MediaQuery maxDeviceWidth={desktopWidth}>
          <button
            className='UserProfileNavBar-toggleVisibilityBtn'
            onClick={onToggleButtonClick}
            >
            <span className={`icon-${buttonClass}`} />
          </button>
        </MediaQuery>

        <MediaQuery minDeviceWidth={desktopWidth + 1}>
          <img src={logoAliada} height='25' />
        </MediaQuery>

      </div>

      <div className='UserProfileNavBar-center'>
        {title}
      </div>

      <div className='UserProfileNavBar-right'>
        <MediaQuery maxDeviceWidth={desktopWidth}>
          <span className='icon-logo' />
        </MediaQuery>
      </div>

    </div>
  )
}

UserProfileNavBar.displayName = 'UserProfileNavBar'
UserProfileNavBar.propTypes = {
  title: PropTypes.string,
  onToggleButtonClick: PropTypes.func.isRequired,
  sidebarExpanded: PropTypes.bool.isRequired
}
UserProfileNavBar.defaultProps = {
  title: ''
}

export default UserProfileNavBar



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/components/UserProfileNavBar/UserProfileNavBar.js